import React, { useContext, useEffect } from 'react';
import { Brain, Zap, Code, Database, BarChart, Shield } from 'lucide-react';
import './linkedin.css';
import { useNavigate } from 'react-router';
import AuthContext from '../SecurityConfig/AuthContext';
import Header from './Header';
const features = [
  {
    icon: <Brain className="icon" />,
    title: 'Topic-Based Post Generation',
    description:
      'Automatically generates professional LinkedIn posts based on the topic provided by the user, using AI-driven content creation.'
  },
  {
    icon: <Zap className="icon" />,
    title: 'Automated LinkedIn Posting',
    description: 'Posts the generated content directly to the user’s LinkedIn account after authentication, saving time and effort.'
  },
  {
    icon: <Code className="icon" />,
    title: 'Local Execution',
    description: 'Allows users to run the application locally, ensuring they have full control over their data and credentials.'
  },
  {
    icon: <Database className="icon" />,
    title: 'No Data Storage',
    description: 'Respects user privacy by not storing any login credentials or generated content on external servers.'
  },
  {
    icon: <BarChart className="icon" />,
    title: 'Smart Content Customization',
    description: 'Tailors posts based on the user’s input, ensuring personalized, high-quality content for maximum engagement.'
  },
  {
    icon: <Shield className="icon" />,
    title: 'Secure and Private',
    description: 'Ensures complete data privacy by keeping all operations client-side with strong security practices.'
  }
];

const BeginnerGuide = () => {
  const navigate = useNavigate();
  const { setLoginDetails, loginDetails } = useContext(AuthContext);
  useEffect(() => {
    if (loginDetails.isAuthenticated) navigate('/linkedinpost/download');
  }, []);
  return (
    <>
      <Header />
      <div className="linkedin">
        <div className="container">
          <div className="wrapper">
            {/* Hero Section */}
            <div className="hero">
              <h1 className="hero-title">
                LinkedIn <span className="highlight">Post</span> Assistant
              </h1>
              <p className="hero-description">
                An intelligent automation tool that processes, analyzes, and transforms your data while providing actionable insights
                through advanced machine learning algorithms.
              </p>
            </div>

            {/* Features */}
            <div className="features-box">
              <h2 className="features-heading">What This AI Utility Does</h2>
              <div className="features-grid">
                {features.map((feature, idx) => (
                  <FeaturePoint key={idx} {...feature} />
                ))}
              </div>
            </div>

            {/* CTA */}
            <div className="cta">
              {/* Optional button */}
              <button className="cta-button" onClick={() => navigate('/linkedinpost/signin')}>
                Try AI Utility Now
              </button>
              <p className="cta-note">No coding knowledge required • Easy setup in minutes</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeaturePoint = ({ icon, title, description }) => (
  <div className="feature-point">
    <div className="icon-container">{icon}</div>
    <div>
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
    </div>
  </div>
);

export default BeginnerGuide;
